// extracted by mini-css-extract-plugin
export default {"root":"wAdDqlxuurBn_ZhtxtQv","placeholderAnimate":"AfX2iKGV5wcSjp5yWjJu"};